import React, {useEffect, useState} from 'react';
import Frame from "../components/layout/Frame";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import BootstrapTable from "react-bootstrap/Table";
import AccRadio from "../layout/pages/user/components/AccRadio";
import Container from "react-bootstrap/Container";
import {getUserACCRList, regUserACCR} from "../api/apiClient";
import Swal from "sweetalert2";

const UserPermission = () => {

  const [stListUserACC, setListUserACC] = useState([]);

  useEffect(() => {
    getUserACCRList().then((res) => {
      if (res.data.data !== undefined) {
        // console.log(res.data.data.list);
        setListUserACC(res.data.data.list);
      }
    });
  }, []);

  const onSubmit = () => {
    let paramList = [];
    let tbody = document.getElementById("tbodyAuthList");
    for (let i = 0, row; row = tbody.rows[i]; i++) {
      let rowId = row.id;
      let targetId = "rb_admin_" + rowId;
      let radios = document.getElementsByName(targetId);
      let targetVal = "";
      for (let i = 0; i < radios.length; i++) {
        let radio = radios[i];
        if (radio.checked) {
          targetVal += radio.value;
        }
      }

      targetId = "rb_user_" + rowId;
      radios = document.getElementsByName(targetId);
      for (let i = 0; i < radios.length; i++) {
        let radio = radios[i];
        if (radio.checked) {
          targetVal += radio.value;
        }
      }
      paramList.push({fnctId: rowId, gradAuthorInfo: targetVal});
    }
    console.log(paramList);

    Swal.fire({
      title: `저장하시겠습니까?`,
      text: `권한별 접근 메뉴 항목을 저장합니다.`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        regUserACCR(paramList).then(res => {
          Swal.fire(
              '정상적으로 처리 되었습니다!',
              '',
              'success',
          );
          window.location.reload(false);
        }).catch(err => {
          Swal.fire(
              err.response.data.message,
              '',
              'error'
          );
        });
      }
    })
  };

  return (
      <Frame
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <Container fluid>
          <Row className={"p-3"}>
            <Col md={12} className={"table-container mt-3 py-2 mw-100"}>
              <Row>
                <Col md={6} className={""}>
                  <Row className={"table-option-container"}>
                    <Col md={12} className={"my-2"}>
                      <Row>
                        <Col md={3} className={""}>
                          <Button
                              type={"button"}
                              className={`btn tab-btn save-btn w-100`}
                              disabled={false}
                              onClick={onSubmit}
                          >저장</Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col md={12}>
                  <div className={"table-responsive text-nowrap"}>
                    <BootstrapTable hover className={"table text-center"}>
                      <thead className={"table-head text-secondary"}>
                      <tr className={"text-start"}>
                        <th className={"col-2 px-5 text-end"}>메뉴명</th>
                        <th className={"col-2"}>관리자</th>
                        <th className={"col-2"}>일반사용자</th>
                        <th className={"col-4"}></th>
                      </tr>
                      </thead>
                      <tbody className={"table-body text-white text-start"} id="tbodyAuthList">

                      {
                        Array.isArray(stListUserACC) ?
                            (stListUserACC.map((elem, idx) => {
                              return (
                                  <tr className={"p-0"} key={idx} id={elem.fnct_id}>
                                    <td className={"p-0 pt-1 px-5 text-end"}>
                                      {elem.fnct_nm}
                                    </td>
                                    <td className={"p-0"}>
                                      <AccRadio
                                          propName={elem.fnct_id}
                                          propAccCode={elem.grad_author_info.substr(0, 1)}
                                          propUser='admin'
                                      />
                                    </td>
                                    <td className={"p-0"}>
                                      <AccRadio
                                          propName={elem.fnct_id}
                                          propAccCode={elem.grad_author_info.substr(1, 2)}
                                          propUser='user'
                                      />
                                    </td>
                                    <td></td>
                                  </tr>);
                            }))
                            : ('')
                      }

                      </tbody>
                    </BootstrapTable>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Frame>
  );
};

export default UserPermission;
